import { render } from "./Slide.vue?vue&type=template&id=5dd0d568&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=5dd0d568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd0d568"]])

export default __exports__